import { styled } from '@mui/system';
import { Card as CardMUI} from "components/ui/Box/Box.styles";

export const Card = styled(CardMUI)`
  margin-bottom: 10px;
`;
